import React, { useState } from 'react'

function InnovativeFeatures() {
   const [activeFeature, setActiveFeature] = useState('indBasicFeatures')

   const basicFeatures = [
      'User Activity Feeds',
      'Photo & Video Uploads',
      'Location-Based Search',
      'User Registration & Login',
      'Favorites & Bookmarking',
      'Push Notifications & Alerts',
      'Privacy & Security Controls',
      'Swipe & Match Functionality',
      'Profile Creation & Customization',
      'In-App Messaging & Real-Time Chat',
   ]

   const advancedFeatures = [
      'Voice & Video Calling',
      'Event & Group Creation',
      'Social Media API Integration',
      'Personalized Content Feeds',
      'Data Analytics & User Insights',
      'Offline Mode for Limited Connectivity',
      'AI-Powered Matchmaking Algorithms',
      'In-App Purchases & Subscription Plans',
      'Advanced Moderation & Reporting Tools',
      'Smart Suggestions Based on Preferences',
   ]
   const handleFeatureClick = (targetId) => {
      setActiveFeature(targetId)
   }

   return (
      <section className="industries-bg-image">
         <div className="container">
            <div className="add-full-border">
               <h2 className="text-center cs-text-secondary tech_title section_heading_title mb-2">
                  Innovative Features You Get With Our Social & Dating App
                  Development
               </h2>
               <p className="section_desc cs-text-secondary mb-0">
                  Benzatine’s social and dating app development solutions are
                  built with powerful, intuitive features designed to enhance
                  user engagement, foster meaningful connections, and deliver
                  seamless experiences. From essential functionalities for
                  profile management to advanced tools for data-driven insights
                  and real-time interactions, we provide scalable, cutting-edge
                  solutions that meet the evolving demands of social networking
                  and dating platforms.
               </p>

               <div className="ind-features-section">
                  <div className="ind-features-btn-group">
                     <div
                        className={`ind-features-btn ${
                           activeFeature === 'indBasicFeatures' ? 'active' : ''
                        }`}
                        id="indBasicFeatures"
                        onClick={() => handleFeatureClick('indBasicFeatures')}
                     >
                        Basic Features
                     </div>
                     <div
                        className={`ind-features-btn ${
                           activeFeature === 'indAdvancedFeatures'
                              ? 'active'
                              : ''
                        }`}
                        id="indAdvancedFeatures"
                        onClick={() =>
                           handleFeatureClick('indAdvancedFeatures')
                        }
                     >
                        Advanced Features
                     </div>
                  </div>
                  <div className="row ind-add-gap">
                     <div className="col-lg-6">
                        <div
                           className={`ind-features-wrap ${
                              activeFeature === 'indBasicFeatures'
                                 ? 'active'
                                 : ''
                           }`}
                           data-target="indBasicFeatures"
                        >
                           {basicFeatures.map((feature, index) => (
                              <div key={index} className="ind-features-list">
                                 <p>
                                    {String(index + 1).padStart(2, '0')}. &nbsp;
                                    {feature}
                                 </p>
                              </div>
                           ))}
                        </div>
                     </div>
                     <div className="col-lg-6">
                        <div
                           className={`ind-features-wrap ${
                              activeFeature === 'indAdvancedFeatures'
                                 ? 'active'
                                 : ''
                           }`}
                           data-target="indAdvancedFeatures"
                        >
                           {advancedFeatures.map((feature, index) => (
                              <div key={index} className="ind-features-list">
                                 <p>
                                    {String(index + 1).padStart(2, '0')}. &nbsp;
                                    {feature}
                                 </p>
                              </div>
                           ))}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default InnovativeFeatures
